import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconMotionTracking = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={25}
      fill="none"
      viewBox="0 0 24 25"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <g clipPath="url(#clip0_4873_3810)" fill="none">
        <path
          d="M11.9714 18.0039V23.869"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9714 1.875V7.74007"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.8395 12.8721H0.974426"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.9684 12.8721H17.1034"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.90696 12.8729C3.90696 13.932 4.11555 14.9807 4.52083 15.9591C4.92611 16.9375 5.52013 17.8265 6.26899 18.5754C7.01784 19.3242 7.90687 19.9183 8.88529 20.3235C9.86372 20.7288 10.9124 20.9374 11.9714 20.9374C13.0305 20.9374 14.0791 20.7288 15.0576 20.3235C16.036 19.9183 16.925 19.3242 17.6739 18.5754C18.4227 17.8265 19.0168 16.9375 19.422 15.9591C19.8273 14.9807 20.0359 13.932 20.0359 12.8729C20.0359 11.8139 19.8273 10.7652 19.422 9.7868C19.0168 8.80838 18.4227 7.91936 17.6739 7.1705C16.925 6.42165 16.036 5.82762 15.0576 5.42234C14.0791 5.01707 13.0305 4.80847 11.9714 4.80847C10.9124 4.80847 9.86372 5.01707 8.88529 5.42234C7.90687 5.82762 7.01784 6.42165 6.26899 7.1705C5.52013 7.91936 4.92611 8.80838 4.52083 9.7868C4.11555 10.7652 3.90696 11.8139 3.90696 12.8729V12.8729Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
